module.exports = __webpack_public_path__ + "img/logo_mdu_white.2c9e1f3f.png";